import { RESET_TYPE } from "../actionTypes.js";
export default function createReset() {
  return {
    type: RESET_TYPE,
    date: new Date()
  };
}